import { call, put } from 'redux-saga/effects';
import ApplyMakeActions from '../redux/ApplyMakeRedux';
import { api } from './api';


export function* applymakesagas(action: any): Generator<any, void, any> {
  const { make_id, make } = action;
  const response = yield call(api.applyMake, make_id, make);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(ApplyMakeActions.applyMakeSuccess(response.data));
  } else {
    yield put(ApplyMakeActions.applyMakeFailure(response.status));
  }
}